import CustomerInvoiceDetails from "./customer-invoice-details";
import CustomerInvoiceList from "./customer-invoice-list";

function CustomerInvoice({ customerId, subpage }) {
  if(subpage) {
    return <CustomerInvoiceDetails customerId={customerId} invoiceId={parseInt(subpage)} />
  } else {
    return <CustomerInvoiceList customerId={customerId} subpage={subpage} />
  }
}

export default CustomerInvoice;